module.exports = __webpack_public_path__ + "static/media/app-store-badge.4800db69.svg";


//////////////////
// WEBPACK FOOTER
// ./src/site-render/src/AppSection/app-store-badge.svg
// module id = 1054
// module chunks = 1